// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"To-z","slideIn":"Uo-z"};